var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQantasLogowine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-18.640065 -6.13375 161.54723 36.8025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(267.169 -369.8882) scale(12.16806)",
    spreadMethod: "pad",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2a5a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280.7643 -358.5987) scale(10.88545)",
    spreadMethod: "pad",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a2a5a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2a5a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-85 -57.3508 -337.7255) scale(2.59616)",
    spreadMethod: "pad",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#a2a5a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2a5a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-124.4 50.9812 -253.2748) scale(29.72696)",
    spreadMethod: "pad",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.9961,
    stopColor: "#be0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.8552-378.8029h-.001l.315.825 1.3975 3.665 7.6387 20.045h25.1638l-20.1638-20.2512c-2.6862-2.6875-6.3325-4.2838-10.1312-4.2838h-4.2188z",
    fill: "url(#a)",
    transform: "translate(-266.8542 378.8029)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7119 4.4901c2.755 4.705 9.985 5.2013 10.7712 12.5175.0325.3.2625.5413.5625.5888 4.1663.6512 8.2238 2.3662 11.75 5.1925l.002.002a.1189.1189 0 00.0787.0275.131.131 0 00.0875-.0337.1263.1263 0 00.004-.1775c-2.4412-2.5663-5.425-4.6175-8.7737-5.965l-1.0188-.41c-.525-.2113-.8887-.7313-.8725-1.33.0562-2.185 5.2263-1.7413 5.75-2.7913l.09-.1812a9.6594 9.6594 0 00-3.7212-1.9763c-.0125.0525-.0462.3075.2362.7688.3088.5025-.3362 1.3-1.2762.4387l-.0787-.0713C8.3179 4.6896 3.0816 8.0084.314.8246l1.3975 3.665z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M283.0277-367.2604v1.7438c.7537-.2175 1.6112-.3525 2.3337-.5038v-.9712s-1.145.0563-1.8475-1.0888c.2088.3413-.0225.8188-.4862.82",
    fill: "url(#b)",
    transform: "translate(-266.8542 378.8029)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280.764-361.0554c3.8612.7425 7.6037 2.41 10.885 5.0413-5.25-4.4863-8.45-5.17-9.9238-5.17-.58 0-.8938.1062-.9613.1287",
    fill: "url(#c)",
    transform: "translate(-266.8542 378.8029)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M267.169-377.9779l1.3974 3.665c2.7538 4.705 9.9838 5.2013 10.7713 12.515-.7963-9.335-4.8963-7.94-9.3013-12.1875-1.1362-.8087-2.0975-1.9937-2.8675-3.9925z",
    fill: "url(#d)",
    transform: "translate(-266.8542 378.8029)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2129 17.3874c2.7162 0 5.0025-1.3438 5.0025-3.1875 0-1.8438-2.2863-3.1875-5.0025-3.1875-2.7163 0-5.0025 1.3437-5.0025 3.1875 0 1.8437 2.2862 3.1875 5.0025 3.1875m-.1425 2.6437c-4.975 0-8.1338-2.5862-8.1338-5.8312 0-3.3013 3.345-5.8313 8.2763-5.8313 4.9312 0 8.2762 2.5438 8.2762 5.7025 0 1.415-.6287 2.5738-1.83 3.545h2.93l-.7 1.2013c-.4437.7575-.9862 1.2137-2.1587 1.2137zm15.2347-4.3304h5.1738l-2.4013-4.2737c-.0563-.1-.1-.1288-.185-.1288-.0863 0-.1287.0288-.1862.1288zm6.5038 2.3588h-7.8325l-1.115 1.9725h-3.245l5.4312-9.405c.4288-.7438 1.0438-1.315 2.2725-1.315h1.215c1.23 0 1.8438.5712 2.2725 1.315l5.4313 9.405h-3.315zm19.8946-8.7478v10.72h-2.9013l-8.5187-7.1037v7.1037H64.381v-10.72h1.8162c.9288 0 1.4.2425 1.9288.7l7.6762 6.39v-7.09zm10.3185 2.4157v8.305h-2.9013v-8.305h-5.9462v-2.415h14.7937v2.415zm9.104 3.9733h5.1737l-2.4012-4.2737c-.0575-.1-.1-.1288-.185-.1288-.0863 0-.1288.0288-.1863.1288zm6.5037 2.3588h-7.8325l-1.115 1.9725h-3.245l5.4313-9.405c.4287-.7438 1.0437-1.315 2.2725-1.315h1.215c1.23 0 1.8437.5712 2.2725 1.315l5.4312 9.405h-3.315zm5.4299 1.2004l-.2712-.0863.7287-2.3288c2.0863.6713 4.3163.9425 6.3313.9425 3.3025 0 4.1175-.3862 4.1175-.8 0-.1712-.115-.3-.3725-.3862-.3288-.1138-1.2438-.3-3.945-.7425-2.9875-.4863-4.33-.73-5.3163-1.1875-.9862-.4563-1.5875-1.1863-1.5875-2.2575 0-.815.4013-1.4725 1.0438-1.9875 1.1437-.8863 3.1012-1.2425 5.2312-1.2425 2.745 0 5.0463.2287 7.6038.8575l.2287.0713-.6137 2.2725c-2.8588-.615-4.445-.7863-6.6175-.815-1.53-.0138-2.5875.1-3.145.2712-.315.1013-.4438.2438-.4438.415 0 .1575.1.3.415.4.3425.115.9.2438 3.83.715 3.1738.515 4.2175.7288 5.0888 1.0725 1.1862.4563 1.9012 1.3 1.9012 2.3575 0 1.33-1.0287 2.3163-2.8162 2.8588-1.1.3287-2.5725.515-4.23.515-2.6013 0-5.375-.3438-7.1613-.915",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQantasLogowine);
export default __webpack_public_path__ + "static/media/Qantas-Logo.wine.f966d574088e49d60cb92a3a554031f6.svg";
export { ForwardRef as ReactComponent };